import { fillArr, randomNum } from '@hglobal/common';
import { environment } from '@pt/environment';
import { Product, ProductShop, OrderProduct } from '@pt/models';

export function getProductMock(id: number): Product {
  return {
    id,
    name: `Product ${id}`,
    mainImage: {
      id,
      url: `${environment.assetsHost}/assets/images/mock-product.png`,
      name: `${id}.jpg`,
    },
    saleImage: (id % 2 === 0)
      ? {
        id: id + 1000,
        url: `${environment.assetsHost}/assets/images/mock-sale-label.png`,
        name: `sale-${id}.jpg`,
      }
      : null,
  };
}

export function getProductsMock(count = 12): Product[] {
  return fillArr(count, i => getProductMock(i));
}

export function getShopProductsMock(count = 12): ProductShop[] {
  return fillArr(count, i => getShopProductMock(i));
}

export function getShopProductMock(id: number): ProductShop {
  const product: ProductShop = {
    ...getProductMock(id),
    price: id * 100,
    sale: !!(id % 2),
    new: !!(id % 2),
  };

  if (id % 2 === 0) {
    product.oldPrice = product.price + 50;
    product.saleImage = {
      id: id + 1000,
      url: `${environment.assetsHost}/assets/images/mock-sale-label.png`,
      name: `sale-${id}.jpg`,
    };
  }
  return product;
}

export function getOrderProductMock(id: number, i: number): OrderProduct {
  return {
    ...getProductMock(id),
    productGlobalId: id,
    price: i * 100,
    oldPrice: i % 2 === 0 ? (i * 100) + 50 : null,
    promo: !!(i % 2),
    quantity: i,
    productOption: {
      id: 1,
      optionSize: i % 2 ? { id: 1, size: 'M' } : null,
      optionColor: i % 2 ? { id: 1, color: 'red', name: 'Red' } : null,
    },
  };
}

export function getOrderProductsMock(parentId: number, count = 5): OrderProduct[] {
  return fillArr(count, i => {
    const id = i + (parentId * 100);
    return getOrderProductMock(id, i);
  });
}
